import useApi from "./useApi";
import { useContext } from "react";
import { HotelContext } from "../context/hotel";

const useStayActions = () => {
    const { get } = useApi();
    const { data } = useContext(HotelContext);

    const getBalanceAndInvoices = async (id) => {
        const response = await get(`hotels/${data.id}/stays/${id}/balance`);
        return response;
    };


    const getStaybyId = async (id) => {
        const response = await get(`hotels/${data.id}/stays/${id}`);
        return response;
    };


    return {
        getBalanceAndInvoices,
        getStaybyId
    };


};
export default useStayActions;
